<template>
  <div>
    <h6> <i :class="mType" :title="item.mediaType"></i>
      <router-link class="text-primary" event="" :to="{ name: 'resourceView', params: { id: item.id }}" @click.native.prevent="viewResource">{{ item.title }}</router-link></h6>

    <p class="meta">
      <span class="meta-bit" v-if="item.url && item.url.indexOf('.')>0"><a :href="item.url" target="new">{{ domainOf(item.url)}}</a><br></span>
      <span class="meta-bit" v-for="(clb,idx) of item.keywords" :key="idx"> {{ clb }} <span v-if="idx<item.keywords.length-1">,</span></span>
     
    </p>
   <p class="meta-desc" v-if="item.description">{{ item.description }}</p>
    <p>
     <TopicLabel class="targ-label"  v-for="(topic,idx) in item.purposeTopicFocus" :target="topic" :key="idx"/>
    </p>
  </div>
</template>
<script>
import TopicLabel from './TopicLabel'
import { mediaTypes } from '../data'

let parser = document.createElement('a')
export default {
  name: 'result',
  props: ['item'],
  components: { TopicLabel },
  computed: {
      mType: function(val){
       var self=this;
       var result = mediaTypes.find(obj => {
        return obj.label === self.item.mediaType
      })
      
       if(result)
       return result.icon;
       else return '';
    }
  },
  methods: {
    domainOf: url => ((parser.href = url), parser.hostname.replace(/^www\./, '')),
    viewResource: function(){
       var event = new CustomEvent("openView", {
              detail: {
                 type:"Resource",
                 id: this.item.id
              }
            });
         this.$emit('openView',event);
     }
  }
}
</script>

<style scoped>

  h3 {
  position: relative; 
  padding-left: 25px; 
  }

 h3:after {
  content: '\f095';
  font-family: fontAwesome;
  position: absolute;
  left: 0; /* Adjust as needed */
  top: 3px; /* Adjust as needed */
  }
  .meta {
    color: #777;
    font-size: .85em;
  }
  .meta-bit {
    color: #333;
    font-weight: bold;
  }

  .meta-bit a{
    font-size: 13px;
  }
  
  .meta-desc{
    overflow:hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }

  .fas{
    color:#afacac;
    margin-right:5px;
  } 

  .targ-label {
    margin-left: 0.4em;
    white-space: nowrap;
    padding: 3px 8px 3px 8px;
    border-radius: 25px;
    color: white;
    font-size: 12px;
    font-weight: bold;
    display: inline-block;
    margin-top: 1em;
  }
</style>


// WEBPACK FOOTER //
// src/plugins/SearchPlugin/components/ResourceResult.vue